import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5561_99999)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.60838 9.39159L1.59564 8.28143C1.51257 8.25077 1.44089 8.19538 1.39027 8.12273C1.33964 8.05008 1.3125 7.96366 1.3125 7.87511C1.3125 7.78656 1.33964 7.70013 1.39027 7.62748C1.44089 7.55483 1.51257 7.49944 1.59564 7.46878L4.60838 6.35862L5.71853 3.34589C5.7492 3.26281 5.80459 3.19114 5.87724 3.14051C5.94989 3.08989 6.03631 3.06274 6.12486 3.06274C6.21341 3.06274 6.29984 3.08989 6.37249 3.14051C6.44514 3.19114 6.50053 3.26281 6.53119 3.34589L7.64135 6.35862L10.6541 7.46878C10.7372 7.49944 10.8088 7.55483 10.8595 7.62748C10.9101 7.70013 10.9372 7.78656 10.9372 7.87511C10.9372 7.96366 10.9101 8.05008 10.8595 8.12273C10.8088 8.19538 10.7372 8.25077 10.6541 8.28143L7.64135 9.39159L6.53119 12.4043C6.50053 12.4874 6.44514 12.5591 6.37249 12.6097C6.29984 12.6603 6.21341 12.6875 6.12486 12.6875C6.03631 12.6875 5.94989 12.6603 5.87724 12.6097C5.80459 12.5591 5.7492 12.4874 5.71853 12.4043L4.60838 9.39159Z",
				stroke: "url(#paint0_linear_5561_99999)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.625 0.875V3.5",
				stroke: "url(#paint1_linear_5561_99999)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.25 3.9375V5.6875",
				stroke: "url(#paint2_linear_5561_99999)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.3125 2.1875H10.9375",
				stroke: "url(#paint3_linear_5561_99999)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.375 4.8125H13.125",
				stroke: "url(#paint4_linear_5561_99999)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_5561_99999",
			x1: 11.8166,
			y1: 7.0021,
			x2: -.568237,
			y2: 7.37446,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A700FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6608C5"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_5561_99999",
			x1: 10.7164,
			y1: 1.9494,
			x2: 9.4286,
			y2: 1.96415,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A700FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6608C5"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_5561_99999",
			x1: 13.3414,
			y1: 4.65377,
			x2: 12.0538,
			y2: 4.67589,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A700FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6608C5"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_5561_99999",
			x1: 11.1774,
			y1: 2.5968,
			x2: 7.81743,
			y2: 2.86197,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A700FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6608C5"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_5561_99999",
			x1: 13.2849,
			y1: 5.2218,
			x2: 11.0372,
			y2: 5.34006,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A700FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6608C5"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5561_99999",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white"
			})
		})
	] })]
});
export default SvgSparkle;
